import { getAllAffectedNodes as u } from "./utils/all-affected.js";
import { isNotAGuard as f, isGuard as s } from "./utils/is.js";
import { getTopCommonParent as l } from "./utils/parenting.js";
import { orderByTabIndex as c } from "./utils/tabOrder.js";
import { getFocusables as t } from "./utils/tabUtils.js";
var A = function(e) {
  var o = u(e).filter(f), m = l(e, e, o), a = c(t([m], !0), !0, !0), i = t(o, !1);
  return a.map(function(n) {
    var r = n.node, d = n.index;
    return {
      node: r,
      index: d,
      lockItem: i.indexOf(r) >= 0,
      guard: s(r)
    };
  });
};
export {
  A as expandFocusableNodes
};
